// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bju8QLeNoDxSTld9pXrp {
  position: relative;
  display: inline-block;
  width: 54.5px;
  height: 28px;
  cursor: pointer;
  border: 1px solid #797979;
  background-color: var(--cardBackground);
  border-radius: 1em;
}
.vPiS5nLfVZ_8IyKuRRjj {
  background-color: var(--eco-green, #28A809);
}
.zwOqXFBs6vIzbS8JDgD5 {
  opacity: 0;
  width: 0;
  height: 0;
}
.VkmWbEK4SsZaV0HU1Ymn {
  position: absolute;
  top: 50%;
  left: 0.15em;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #797979;
  background-color: transparent;
  transition: all 0.3s ease;
  transform: translateY(-50%);
}
.vPiS5nLfVZ_8IyKuRRjj .VkmWbEK4SsZaV0HU1Ymn {
  left: calc(100% - 1.8em);
  background-color: white;
  border: 0.5px solid #ABB0A4;
}
/* Segmented variant (Hot & Cold switch) */
.bvK4lAHSaB0zQL2Ij_fv {
  width: 291px;
  height: 51px;
  border: 3px solid #270009;
  border-radius: 10px;
  background-color: #0F0103CC;
  backdrop-filter: blur(3px);
}
.bvK4lAHSaB0zQL2Ij_fv.vPiS5nLfVZ_8IyKuRRjj {
  border-color: #003567;
  background-color: #0E1729CC;
}
.bvK4lAHSaB0zQL2Ij_fv .VkmWbEK4SsZaV0HU1Ymn {
  left: 4.75px;
  z-index: 0;
  width: 134px;
  height: 35.5px;
  border: 1.5px solid #F9B901;
  border-radius: 6px;
  background: linear-gradient(180deg, #F82A00 -15%, #D31002 54.17%, #F82A00 123.33%);
  box-shadow: 0 0 4.737px 1.184px #FC4000 inset, 0 0 5.921px 2.368px #BA2002;
  transition: all 0.3s ease-out;
}
.bvK4lAHSaB0zQL2Ij_fv.vPiS5nLfVZ_8IyKuRRjj .VkmWbEK4SsZaV0HU1Ymn {
  left: calc(100% - 138.75px);
  border-color: #28DFFF;
  background: linear-gradient(180deg, #0595FE -11.67%, #0383FE 51.19%, #0595FE 111.67%);
  box-shadow: 0 0 4.737px 1.184px #06CCFF inset, 0 0 4.737px 2.368px #006AE3;
}
.nO7WSuX6nIep3eeKwkuL {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
  text-transform: uppercase;
}
.H71uEhmIzXPvijeli2Ur {
  justify-self: center;
  color: #FFFFFF;
}
.hMh7Jirw_sf2XhHc75iN {
  justify-self: center;
  color: #B4B4B4;
}
.bvK4lAHSaB0zQL2Ij_fv.vPiS5nLfVZ_8IyKuRRjj .H71uEhmIzXPvijeli2Ur {
  color: #B4B4B4;
}
.bvK4lAHSaB0zQL2Ij_fv.vPiS5nLfVZ_8IyKuRRjj .hMh7Jirw_sf2XhHc75iN {
  color: #FFFFFF;
}
@media (max-width: 1025px) {
  .bvK4lAHSaB0zQL2Ij_fv {
    width: 194px;
    height: 34px;
    border-width: 2px;
  }
  .bvK4lAHSaB0zQL2Ij_fv .VkmWbEK4SsZaV0HU1Ymn {
    left: 3.17px;
    width: 89.5px;
    height: 23.5px;
    border-width: 1px;
    box-shadow: 0 0 3.158px 0.789px #FC4000 inset, 0 0 3.947px 1.579px #BA2002;
  }
  .bvK4lAHSaB0zQL2Ij_fv.vPiS5nLfVZ_8IyKuRRjj .VkmWbEK4SsZaV0HU1Ymn {
    left: calc(100% - 92.6px);
    box-shadow: 0 0 3.158px 0.789px #06CCFF inset, 0 0 3.158px 1.579px #006AE3;
  }
  .nO7WSuX6nIep3eeKwkuL {
    font-size: 14.21px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/ToggleSwitch/ToggleSwitch.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,uCAAuC;EACvC,kBAAkB;AACpB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA,0CAA0C;AAC1C;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,kFAAkF;EAClF,0EAA0E;EAC1E,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,qFAAqF;EACrF,0EAA0E;AAC5E;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,YAAY;IACZ,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,0EAA0E;EAC5E;EACA;IACE,yBAAyB;IACzB,0EAA0E;EAC5E;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".switchContainer {\n  position: relative;\n  display: inline-block;\n  width: 54.5px;\n  height: 28px;\n  cursor: pointer;\n  border: 1px solid #797979;\n  background-color: var(--cardBackground);\n  border-radius: 1em;\n}\n.checked {\n  background-color: var(--eco-green, #28A809);\n}\n.switchInput {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.slider {\n  position: absolute;\n  top: 50%;\n  left: 0.15em;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  border: 1px solid #797979;\n  background-color: transparent;\n  transition: all 0.3s ease;\n  transform: translateY(-50%);\n}\n.checked .slider {\n  left: calc(100% - 1.8em);\n  background-color: white;\n  border: 0.5px solid #ABB0A4;\n}\n/* Segmented variant (Hot & Cold switch) */\n.segmented {\n  width: 291px;\n  height: 51px;\n  border: 3px solid #270009;\n  border-radius: 10px;\n  background-color: #0F0103CC;\n  backdrop-filter: blur(3px);\n}\n.segmented.checked {\n  border-color: #003567;\n  background-color: #0E1729CC;\n}\n.segmented .slider {\n  left: 4.75px;\n  z-index: 0;\n  width: 134px;\n  height: 35.5px;\n  border: 1.5px solid #F9B901;\n  border-radius: 6px;\n  background: linear-gradient(180deg, #F82A00 -15%, #D31002 54.17%, #F82A00 123.33%);\n  box-shadow: 0 0 4.737px 1.184px #FC4000 inset, 0 0 5.921px 2.368px #BA2002;\n  transition: all 0.3s ease-out;\n}\n.segmented.checked .slider {\n  left: calc(100% - 138.75px);\n  border-color: #28DFFF;\n  background: linear-gradient(180deg, #0595FE -11.67%, #0383FE 51.19%, #0595FE 111.67%);\n  box-shadow: 0 0 4.737px 1.184px #06CCFF inset, 0 0 4.737px 2.368px #006AE3;\n}\n.segmentedLabels {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  align-items: center;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1;\n  text-transform: uppercase;\n}\n.leftLabel {\n  justify-self: center;\n  color: #FFFFFF;\n}\n.rightLabel {\n  justify-self: center;\n  color: #B4B4B4;\n}\n.segmented.checked .leftLabel {\n  color: #B4B4B4;\n}\n.segmented.checked .rightLabel {\n  color: #FFFFFF;\n}\n@media (max-width: 1025px) {\n  .segmented {\n    width: 194px;\n    height: 34px;\n    border-width: 2px;\n  }\n  .segmented .slider {\n    left: 3.17px;\n    width: 89.5px;\n    height: 23.5px;\n    border-width: 1px;\n    box-shadow: 0 0 3.158px 0.789px #FC4000 inset, 0 0 3.947px 1.579px #BA2002;\n  }\n  .segmented.checked .slider {\n    left: calc(100% - 92.6px);\n    box-shadow: 0 0 3.158px 0.789px #06CCFF inset, 0 0 3.158px 1.579px #006AE3;\n  }\n  .segmentedLabels {\n    font-size: 14.21px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switchContainer": `bju8QLeNoDxSTld9pXrp`,
	"checked": `vPiS5nLfVZ_8IyKuRRjj`,
	"switchInput": `zwOqXFBs6vIzbS8JDgD5`,
	"slider": `VkmWbEK4SsZaV0HU1Ymn`,
	"segmented": `bvK4lAHSaB0zQL2Ij_fv`,
	"segmentedLabels": `nO7WSuX6nIep3eeKwkuL`,
	"leftLabel": `H71uEhmIzXPvijeli2Ur`,
	"rightLabel": `hMh7Jirw_sf2XhHc75iN`
};
export default ___CSS_LOADER_EXPORT___;
